import useSWRImmutable from 'swr/immutable';

import { dayjsesToFormatedDate, getDefaultDates } from 'src/utils/date-util';
import { getProductOutboundTransactions } from 'src/utils/firebase/firebase-short-cut';

const fetcher = async (inventoryId: string | undefined) => {
  const defaultValue = getDefaultDates(30, 1);
  const [startValue, endValue] = dayjsesToFormatedDate(defaultValue[0], defaultValue[1], 'yyyy-MM-dd');
  if (!inventoryId) return undefined;
  return getProductOutboundTransactions([['inventoryId', '==', inventoryId]], {
    sortKey: 'requestDate',
    orderBy: 'desc',
    startValue,
    endValue,
  });
};

const useSWRProductOutboundTxns = (inventoryId: string | undefined) => {
  const {
    data: productOutboundTransactions,
    isLoading,
    error,
  } = useSWRImmutable(inventoryId ? `productOutboundTransactions-${inventoryId}` : null, () => fetcher(inventoryId));

  return {
    productOutboundTransactions,
    isLoading,
    error,
  };
};

export default useSWRProductOutboundTxns;
